import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { GooglePayButtonModule } from '@google-pay/button-angular';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { ButtonModule, LoadingIndicatorModule, TemplateVariablesModule } from '@platform-frontend/ui-tools';
import { ApplePayButtonComponent } from './apple-pay-button/apple-pay-button.component';
import { GooglePayButtonComponent } from './google-pay-button/google-pay-button.component';
import { WalletButtonComponent } from './wallet-button/wallet-button.component';

@NgModule({
  declarations: [GooglePayButtonComponent, ApplePayButtonComponent, WalletButtonComponent],
  imports: [ButtonModule, CommonModule, GooglePayButtonModule, LoadingIndicatorModule, TemplateVariablesModule, TranslocoModule, TranslocoLocaleModule],
  exports: [GooglePayButtonComponent, ApplePayButtonComponent, WalletButtonComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PaymentWalletButtonModule {}
